<template>
  <div class="store-layout">
    <!-- 側邊欄 -->
    <aside class="sidebar" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
      <div class="sidebar-header">
        <h3 v-if="!sidebarCollapsed">商家後台</h3>
        <button @click="toggleSidebar" class="sidebar-toggle">
          <i class="fas fa-bars"></i>
        </button>
      </div>
      
      <nav class="sidebar-nav">
        <router-link to="/store" class="nav-item" active-class="active">
          <i class="fas fa-tachometer-alt"></i>
          <span v-if="!sidebarCollapsed">儀表板</span>
        </router-link>
        
        <router-link to="/store/products" class="nav-item" active-class="active">
          <i class="fas fa-box"></i>
          <span v-if="!sidebarCollapsed">商品管理</span>
        </router-link>
        
        <router-link to="/store/categories" class="nav-item" active-class="active">
          <i class="fas fa-list"></i>
          <span v-if="!sidebarCollapsed">分類管理</span>
        </router-link>
        
        <router-link to="/store/orders" class="nav-item" active-class="active">
          <i class="fas fa-shopping-cart"></i>
          <span v-if="!sidebarCollapsed">訂單管理</span>
        </router-link>
        
        <router-link to="/store/customers" class="nav-item" active-class="active">
          <i class="fas fa-users"></i>
          <span v-if="!sidebarCollapsed">客戶管理</span>
        </router-link>
        
        <router-link to="/store/labels" class="nav-item" active-class="active">
          <i class="fas fa-tags"></i>
          <span v-if="!sidebarCollapsed">標籤管理</span>
        </router-link>
        
        <router-link to="/store/news" class="nav-item" active-class="active">
          <i class="fas fa-newspaper"></i>
          <span v-if="!sidebarCollapsed">新聞管理</span>
        </router-link>
        
        <router-link to="/store/navigation" class="nav-item" active-class="active">
          <i class="fas fa-bars"></i>
          <span v-if="!sidebarCollapsed">導航列管理</span>
        </router-link>
        
        <router-link to="/store/settings" class="nav-item" active-class="active">
          <i class="fas fa-cog"></i>
          <span v-if="!sidebarCollapsed">商店設定</span>
        </router-link>
      </nav>
    </aside>

    <!-- 主要內容區域 -->
    <main class="main-content" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
      <!-- 頂部導航欄 -->
      <header class="top-header">
        <div class="header-left">
          <button @click="toggleSidebar" class="menu-toggle">
            <i class="fas fa-bars"></i>
          </button>
          <div class="breadcrumb">
            <span>{{ currentPageTitle }}</span>
          </div>
        </div>
        
        <div class="header-right">
          <div class="user-menu-static">
            <div class="user-info">
              <span class="user-name">{{ currentUser?.name || '商家' }}</span>
              <span class="user-role">商店管理員</span>
            </div>
            <div class="user-avatar">
              <img v-if="currentUser?.avatar" :src="currentUser.avatar" :alt="currentUser.name">
              <div v-else class="avatar-placeholder">
                <i class="fas fa-user"></i>
              </div>
            </div>
            <router-link to="/member" class="user-menu-btn">
              <i class="fas fa-user"></i> 個人資料
            </router-link>
            <router-link to="/" class="user-menu-btn">
              <i class="fas fa-home"></i> 回到前台
            </router-link>
            <button @click="logout" class="user-menu-btn">
              <i class="fas fa-sign-out-alt"></i> 登出
            </button>
          </div>
        </div>
      </header>

      <!-- 頁面內容 -->
      <div class="page-content">
        <div v-if="!storeInfo" class="loading">載入商店資料中...</div>
        <slot v-else></slot>
      </div>
    </main>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'StoreLayout',
  data() {
    return {
      sidebarCollapsed: false
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    ...mapState(['storeInfo']),
    currentPageTitle() {
      const routeTitles = {
        'StoreDashboard': '儀表板',
        'StoreProducts': '商品管理',
        'StoreCategories': '分類管理',
        'StoreOrders': '訂單管理',
        'StoreCustomers': '客戶管理',
        'StoreLabels': '標籤管理',
        'StoreNews': '新聞管理',
        'StoreNavigation': '導航列管理',
        'StoreSettings': '商店設定'
      }
      return routeTitles[this.$route.name] || '商家後台'
    }
  },
  async mounted() {
    if (!this.storeInfo) {
      await this.$store.dispatch('fetchStoreInfo')
    }
  },
  methods: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
    },
    async logout() {
      try {
        await this.$store.dispatch('userLogout')
        this.$router.push('/store/login')
      } catch (error) {
        console.error('登出失敗:', error)
      }
    }
  }
}
</script>

<style scoped>
.store-layout {
  display: flex;
  min-height: 100vh;
  background-color: #f8f9fa;
}

.sidebar {
  width: 250px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  transition: width 0.3s ease;
  position: fixed;
  height: 100vh;
  z-index: 1000;
  overflow-y: auto;
}

.sidebar-collapsed {
  width: 60px;
}

.sidebar-header {
  padding: 1.5rem;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sidebar-header h3 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
}

.sidebar-toggle {
  background: none;
  border: none;
  color: white;
  font-size: 1.1rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.sidebar-toggle:hover {
  background-color: rgba(255,255,255,0.1);
}

.sidebar-nav {
  padding: 1rem 0;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  color: rgba(255,255,255,0.8);
  text-decoration: none;
  transition: all 0.3s;
  border-left: 3px solid transparent;
}

.nav-item:hover {
  background-color: rgba(255,255,255,0.1);
  color: white;
}

.nav-item.active {
  background-color: rgba(255,255,255,0.2);
  color: white;
  border-left-color: white;
}

.nav-item i {
  font-size: 1.1rem;
  min-width: 20px;
  text-align: center;
}

.main-content {
  flex: 1;
  margin-left: 250px;
  transition: margin-left 0.3s ease;
  display: flex;
  flex-direction: column;
}

.main-content.sidebar-collapsed {
  margin-left: 60px;
}

.top-header {
  background: white;
  padding: 1rem 2rem;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.menu-toggle {
  background: none;
  border: none;
  font-size: 1.1rem;
  color: #6c757d;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.menu-toggle:hover {
  background-color: #f8f9fa;
}

.breadcrumb {
  font-weight: 500;
  color: #2c3e50;
  font-size: 1.1rem;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-menu-static {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem;
  border-radius: 8px;
  background: #f8f9fa;
}

.user-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.user-name {
  font-weight: 500;
  color: #2c3e50;
  font-size: 0.9rem;
}

.user-role {
  font-size: 0.8rem;
  color: #6c757d;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
}

.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  background-color: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
}

.user-menu-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  color: #2c3e50;
  background: none;
  border: none;
  border-radius: 6px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  text-decoration: none;
}

.user-menu-btn:hover {
  background-color: #e9ecef;
}

.page-content {
  flex: 1;
  padding: 2rem;
  overflow-y: auto;
}

.loading {
  text-align: center;
  font-size: 1.2rem;
  color: #666;
  padding: 3rem 0;
}

@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
    position: fixed;
  }
  
  .sidebar.show {
    transform: translateX(0);
  }
  
  .main-content {
    margin-left: 0;
  }
  
  .top-header {
    padding: 1rem;
  }
  
  .user-info {
    display: none;
  }
  
  .page-content {
    padding: 1rem;
  }
}
</style> 